import React, { useEffect, useState } from 'react'
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { AiOutlinePlus, AiOutlineCheck } from "react-icons/ai";
import axios from 'axios';
import { gettoken } from '../Localstorage/Store';
import { IoIosArrowDown } from "react-icons/io";
import { crequest } from '../Validation/crequest';
import { useFormik } from "formik";
import Loader from '../components/Loader';
import { IoMdArrowRoundBack } from "react-icons/io";
import {  useSelector } from "react-redux";
import Accountprice from '../utils/Accountprice';

export const Creditrequestlist = () => {


  const { bgColor, textColor } = useSelector((state) => state.theam);

  const nvg = useNavigate()
  const [data, setData] = useState([]);
  const [error, seterror] = useState("No Record found !");



  const [datastatus, setDatastatus] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  console.log("selectedStatus", selectedStatuses)
  const [selectedDuration, setSelectedDuration] = useState(null);
  console.log(selectedDuration, "selectedDuration")



  const [userloader, setuserloader] = useState(false);
  const [creditamount, setcreditamount] = useState(0);

  const tokenvalue = gettoken();
  const [loading, setloading] = useState(false)
  const currentwdith = window.innerWidth;







  const clearFilter = () => {
    setSelectedStatuses([]); // Clear selectedStatuses array
    setSelectedDuration(null);
    fetchcategory() // Reset selectedDuration to null (or initial value)
  };

  useEffect(() => {
    async function fetchstatus() {
      const config = {
        headers: {
          Authorization: `Bearer ${tokenvalue.access}`,
        },
      };
      let url = `${process.env.REACT_APP_API_URL}credit/credit-request-user/${tokenvalue.id}`;

      const response = await axios.get(url, config);
      setDatastatus(response.data);
    }



    async function creditAmountCheck() {
      // console.log(tokenvalue.access);
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${tokenvalue.access}`,
          },
        };
        setuserloader(true);
        let url = `${process.env.REACT_APP_API_URL}credit/total_amount/`;
        const response = await axios.get(url, config);
        // console.log("this is wallet amount", response);
        console.log(response.status);
        if ((response.status = "200")) {
          setcreditamount(response.data.amount);
          // setcreditminusamount(response.data.minus_amount)
          // setcreditshippingstatus(response.data.shipping_value)
        // settotalcredit(response.data.amount);
          // setuserloader(false);
          // console.log(response.amount);
          // return response.data.amount;
        }

        //  setloading(false)
      } catch (error) {}
    }

    creditAmountCheck()
    fetchstatus()

  }, [])
  const [searchTerm, setSearchTerm] = useState('');
  const handleSearch = async () => {
    if (searchTerm == '') {
      fetchcategory()
    } else {
      const searchTermLower = searchTerm.trim().toLowerCase();

      const filteredOrders = data.filter(order =>
        order.number.toLowerCase().includes(searchTermLower)
      );
      setData(filteredOrders)

      console.log('Filtered orders:', filteredOrders);
      if (data.length > 0 && selectedDuration) {
        if (selectedDuration == '360') {
          const errorMessage = "No orders found last one year "
          seterror(errorMessage);

        } if (selectedDuration == '180') {
          const errorMessage = "No orders found last six Month "
          seterror(errorMessage);

        }
        if (selectedDuration == '30') {
          const errorMessage = "No orders found last 30 Days "
          seterror(errorMessage);

        }
        if (selectedDuration == '15') {
          const errorMessage = "No orders found last 15 Days "
          seterror(errorMessage);

        }



      }
    }

  };



  async function fetchcategory() {
    setloading(true)
    let url = `${process.env.REACT_APP_API_URL}credit/credit-request-user/${tokenvalue.id}`;

    // let url = ${process.env.REACT_APP_API_URL}api/orders/;
    const response = await axios.get(url);
    console.log("order history response", response)
    console.log("order history response data", response.data)

    setData(response.data['Credit Request Data']);
    setloading(false)
  }
  useEffect(() => {

    fetchcategory()

  }, [])



  const [success, setsuccess] = useState("");

  const vrequestfrom = async (values, action, setFieldError) => {
    console.log("values of fiedl",values);
    setloading(true)
        try {
    
    
          let data = {
              user: tokenvalue.id,
               amount: values.amount,
               status:'Requested'
            };
         
          let url = `${process.env.REACT_APP_API_URL}credit/credit-request-user/`;
          const response = await axios.post(url, data);
          console.log("sssssssssssssssssssss", response);
          action();
          const requestId = response.data.credit_request_id;  // Extract the UUID from the response
          setsuccess(`Request sent successfully. Your request ID is: ${requestId}`);
          setloading(false);
          fetchcategory()
          setTimeout(() => {
            nvg('/creditrequest')
          }, 5000);
          // if (multiselectRef.current) {
          //   multiselectRef.current.resetSelectedValues();
          // }
         
          setTimeout(() => {
            setsuccess("");
          }, 3000);
        } catch (error) {
          setloading(false)
          console.log("this ier eror msf",error)
        }
      };




  const initialValues = {
    amount: "",
  };

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldError,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: crequest,
    onSubmit: (values, { setFieldError, resetForm }) => {
      console.log("vialdldldld", values);
        vrequestfrom(values, resetForm, setFieldError);
    },
  });



  return (
    <div>
      <Header />

      <div>
        {/* breadcrumb start */}
        <div className="breadcrumb-main marginfromtop" style={{ background: "#fff" }}>
          <div className="container m-0">
            <div className="row">
              <div className="col">
                <div className="breadcrumb-contain">
                  <div>
                    <ul>
                      <li><a href="/home">home</a></li>
                      <li>{`>`}</li>
                      <li><a href="javascript:void(0)">Credits Request </a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* breadcrumb End */}
        {loading == true ? <div className='d-flex justify-content-center align-items-center mt-5 pb-5 mb-5'><span className='pb-5'><Loader /></span></div> : <div>
          <section className="section-big-pt-space py-1 " style={{ background: "#f9f9f9" }}>
            <div className="col-lg-12 col-sm-12 col-xs-12 mt-lg-4 mt-xs-4 mb-5">

              <div className="container-fuild emp-profile">
                <div className="row pro justify-content-center">


                  {/* <div id="tab-2" style={{ display: owl == 'tab-2' ? 'block' : 'none' }} className={owl == 'tab-2' ? "tab-content active default product-block3" : "tab-content product-block3"}> */}
                  <div className="row py-xl-4 py-3">



                  <div
                    className="col-xl-10 col-md-12 offset-xl-1 offset-md-0 pt-2"
                    style={{ display: success == "" ? "none" : "block" }}
                  >
                    <div class="alert alert-success" role="alert">
                      {success}
                    </div>
                    </div>
                    <div className={"col-xl-10 col-md-12 offset-xl-1 offset-md-0 Ohistory"} style={{ padding: "0px 4px" }} >
                      <h3 style={{ color: `#${textColor}`}} className='pb-xl-0 pb-md-0 pb-2'> <span   onClick={() => {
                                    nvg("/mycredit");
                                  }} ><IoMdArrowRoundBack /></span> Credits Request</h3>
                      </div>
                    <div className={"col-xl-10 col-md-12 offset-xl-1 offset-md-0 Ohistory"} style={{ padding: "0px 4px" }} >
                      <div className="input-group mb-3" style={{ gap: '10px', justifyContent: 'space-between',alignItems:'end' }}>
                        <span>
                        Credit Available 
                        {/* ₹ */}
                         {Accountprice(creditamount)}
                        </span>
                        <span style={{fontSize:'19px',fontWeight:'500',display:success ? '' : 'none'}}>
                        </span>
              
                                      <form className="theme-form" onSubmit={handleSubmit}>
                        <div className='d-flex' style={{gap:'5px'}}>
                        <input type="tel" className='form-control'
                                                value={values.amount}
                                                onChange={(e)=>{setFieldValue("amount",e.target.value.replace(/\D/g, ''))}}
                                                placeholder='Enter Amount' style={{borderRadius:'0px',fontSize:'13px'}}  />
                        <button
                          className='Sbtn btn btn-outline-secondary'
                          style={{  backgroundColor: `#${bgColor}`, color: 'white', borderRadius: '0px', fontSize: "13px",textWrap:'nowrap' }}
                          type="submit"
                          id="button-addon2"
                          // onClick={() => { nvg('/addcreditrequest') }}
                        >
                          {/* <i className="fa fa-search"></i> */}
                          <span style={{ fontSize: '18px' }}>+</span>&nbsp; Add Request 
                        </button> 
                        
                        </div>
                        </form>
                      </div>
                      {/* <div className="filter-main-btn m-0" style={{display :currentwdith < 730 ? "block" : "none"}} onClick={()=>{setfilter(!filter)}}><span className="filter-btn  "><i className="fa fa-filter" aria-hidden="true" /> Filter</span></div> */}
                      <div className="filter-main-btn m-0" style={{ display: currentwdith < 730 ? "block" : "none" }} >          <button
                        type="button"
                        className="hidecontent my-2"
                        style={{
                          border: "none",
                          outline: "none",
                          backgroundColor: "white",
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalfour"
                      >
                        {/* <span className="filter-btn " style={{ fontSize: '12px' }}><i className="fa fa-filter" aria-hidden="true" /> Filter</span> */}
                      </button></div>

                      <div className="table-responsive" >
                        <table className="table  orstatus" >

                          {/* <table className="table"> */}
                          <thead>
                            <tr>

                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>S.No</div></th>
                              
                              {/* <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Voucher Name</div></th> */}
 <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Request Id </div></th>
                              {/* <th scope="col"><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Voucher Qty</div></th> */}






                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Credit Amount</div></th>
                                 
                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}> Date</div></th>
                              <th scope="col" ><div style={{
                                fontWeight: 600, fontSize: "12px", display: "-webkit-box",
                                WebkitLineClamp: "1",
                                textAlign: "center",
                                textWrap: 'nowrap',
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}>Status</div></th>
                            </tr>
                          </thead>
                          {/* </table> */}



                          <thead className="table-light" style={{ paddingTop: '20px' }}>
                            <tr>

                            </tr>
                          </thead>
                          <tbody >
                            {data[0] ? (data.map((item, index) => (
                              <tr key={index}>


                                <td style={{ color: '#0cb744', paddingTop: '20px', textAlign: "center", fontSize: '12px' }}>

                                  <h5
                                    //  onClick={() => { nvg(/order-history-detail/${item.number}) }}
                                    style={{ fontSize: "12px", lineHeight: "22px", cursor: 'pointer', position: 'relative' }}> {1 + index}</h5>
                                </td>
                                {/* <td style={{ color: '', paddingTop: '20px', textAlign: "center", fontSize: '12px' }}>

                    
                                  {item.voucher_request_name}
                          
                                </td> */}



                                <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px' }}>{item.credit_request_id}</td>


                                {/* <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px', position: 'relative', left: "10px" }}>{item.no_of_vouchers} </td> */}
                                <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px' }}>
                                  {/* ₹ */}
                                  {Accountprice(item.amount)}</td>
                                

                                <td style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px', }}> {new Date(item.submission_date.split('Time')[0]).toLocaleDateString('en-GB', {
                                  hour: 'numeric',
                                  minute: 'numeric'
                                }


                                )}</td>


                                <td 
                                // className='d-flex justify-content-center'
                                style={{ paddingTop: '20px', textAlign: "center", fontSize: '12px', }}>
                                  {/* <p style={{ paddingTop: '15px', width: "115px", fontSize: '12px', textAlign: 'center' }}>  &nbsp;    */}
                                                {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                  {/* </p> */}
                                </td>

                              </tr>
                            ))) : (
                              <tr>
                                <td
                                  colSpan={5}
                                  className="text-center"
                                  style={{ fontWeight: "500" }}
                                >
                                  {error}
                                </td>
                              </tr>
                            )}



                          </tbody>
                        </table>
                      </div>

                      <div className="col-xl-12 d-flex justify-content-end" >
                    <div>
                      {/* <button
                                  type="button"
                                  style={{
                                    fontSize: "12px",
                                    background: "#bdbfc0",
                                    color: "#000",
                                  }}
                                  className="btn-normal btn"
                                  // data-bs-dismiss="modal"
                                  // aria-label="Close"
                                  onClick={() => {
                                    nvg("/mycredit");
                                  }}
                                >
                                  Back
                                </button> */}
                    </div>
                    </div>



                    </div>

                  </div>






                </div>
              </div>
            </div>
          </section>

        </div>}
        


        <Footer />
      </div>


    </div>
  )
}
export default Creditrequestlist;